const mainBottle = document.querySelector('#main-bottle');
const violetBottle = document.querySelector('#bottle-violet');
const pinkBottle = document.querySelector('#bottle-pink');
const scrollElVer = document.querySelectorAll('.elVer');
const scrollElRound = document.querySelector('.elRound');
const scrollElHor = document.querySelectorAll('.elHor');
const scrollBottle = document.querySelector('.bottle');
const heroSeparator = document.querySelector('.hero__separator');
const rulesContent = document.querySelector('.rules__content');
const hero = document.querySelector('.hero');

const heroBufer = document.querySelector('.hero__bufer');

const breakpointMd = window.matchMedia('(min-width:768px)');
const breakpointLg = window.matchMedia('(min-width:1024px)');
const breakpointXl = window.matchMedia('(min-width:1440px)');
const bufer = document.querySelector('.bufer-bottom');

let windowHeight;
let windowHeightAfterFix;
let buferTop;
let mainBottleLeft;
let separatorSvg;
let windowWidth;

const moveMainBottle = (scrollY) => {
  let speed = mainBottle.dataset.speed;
  if (breakpointLg.matches) {
    if (scrollY === 0) {
      mainBottle.classList.remove('move');
      mainBottle.style.transform = null;
      // document.querySelector('.rules').style.position = null;
      document.querySelector('.rules').style.top = null;

    } else if (scrollY > 0 && scrollY < windowHeight) {
      mainBottle.classList.add('move');
      hero.classList.remove('load');
      mainBottle.style.position = "fixed";
      mainBottle.style.right = 'unset';
      document.querySelector('.rules').style.top = `${windowHeight - scrollY}px`;
    } else if (scrollY >= windowHeight && scrollY <= windowHeightAfterFix) {
      mainBottle.classList.add('move');
      hero.classList.remove('load');
      mainBottle.style.transform = `translate3d(0, 0, 0) rotate(0)`;
      mainBottle.style.position = 'fixed';
      mainBottle.style.right = 'unset';
      document.querySelector('.rules').style.top = 0;
    } else if (scrollY > windowHeightAfterFix) {
      mainBottle.classList.add('move');
      hero.classList.remove('load');
      document.querySelector('.rules').style.position = null;
      document.querySelector('.rules').style.top = 0;
      mainBottle.style.transform = `translate3d(${(scrollY - windowHeightAfterFix) * 0.5}px, -${(scrollY - windowHeightAfterFix) * speed}px, 0) rotate(0)`;
    }
  } else if (breakpointMd.matches) {
    if (scrollY === 0) {
      mainBottle.classList.remove('move');
      mainBottle.style.transform = null;
      document.querySelector('.rules').style.position = null;
      document.querySelector('.rules').style.top = null;
      mainBottle.style.position = null;

    } else if (scrollY > 0 && scrollY < windowHeight) {
      mainBottle.classList.add('move');
      hero.classList.remove('load');
      mainBottle.style.transform = `translate3d(-${scrollY / 6}px, -${(scrollY * 0.05)}px, 0)`;
      document.querySelector('.rules').style.position = null;
      document.querySelector('.rules').style.top = `${windowHeight - scrollY}px`;
    } else if (scrollY >= windowHeight && scrollY <= windowHeightAfterFix) {
      mainBottle.classList.add('move');
      hero.classList.remove('load');
      mainBottle.style.transform = `translate3d(-${(windowHeight / 6)}px, -${(windowHeight * 0.05)}px, 0)`;
      document.querySelector('.rules').style.position = 'fixed';
      document.querySelector('.rules').style.top = 0;
    } else if (scrollY > windowHeightAfterFix) {
      mainBottle.classList.add('move');
      hero.classList.remove('load');
      document.querySelector('.rules').style.position = 'absolute';
      document.querySelector('.rules').style.top = `${windowHeightAfterFix}px`;
      mainBottle.style.transform = `translate3d(-${(windowHeight / 6)}px, -${((scrollY - (windowHeightAfterFix - (windowHeight * 0.03))) * 2)}px, 0)`;
    }
  } else {
    if (scrollY === 0) {
      mainBottle.classList.remove('move');
      mainBottle.style.transform = null;
      document.querySelector('.rules').style.position = null;
      document.querySelector('.rules').style.top = null;
      mainBottle.style.position = null;
    } else if (scrollY > 0 && scrollY < windowHeight) {
      mainBottle.classList.add('move');
      hero.classList.remove('load');
      mainBottle.style.transform = `translate3d(-${scrollY / 9.3}px, -${(scrollY * 0.19)}px, 0)`;
      document.querySelector('.rules').style.position = null;
      document.querySelector('.rules').style.top = `${windowHeight - scrollY}px`;
    } else if (scrollY >= windowHeight && scrollY <= windowHeightAfterFix) {
      mainBottle.classList.add('move');
      hero.classList.remove('load');
      mainBottle.style.transform = `translate3d(-${(windowHeight / 9.3)}px, -${(windowHeight * 0.19)}px, 0)`;
      document.querySelector('.rules').style.position = 'fixed';
      document.querySelector('.rules').style.top = 0;
    } else if (scrollY > windowHeightAfterFix) {
      mainBottle.classList.add('move');
      hero.classList.remove('load');
      document.querySelector('.rules').style.position = 'absolute';
      document.querySelector('.rules').style.top = `${windowHeightAfterFix}px`;
      mainBottle.style.transform = `translate3d(-${(windowHeight / 9.3)}px, -${((scrollY - (windowHeightAfterFix - (windowHeight * 0.098))) * 2)}px, 0)`;
    }
  }

}

const moveVioletBottle = (scrollY) => {
  if (scrollY > windowHeightAfterFix) {
    let speedViolet = violetBottle.dataset.speed;
    let speedPink= pinkBottle.dataset.speed;
    violetBottle.style.transform = `translate3d(${windowHeightAfterFix - scrollY}px, -${(scrollY - windowHeightAfterFix) * speedViolet}px, 0)`;
    pinkBottle.style.transform = `translate3d(${scrollY - windowHeightAfterFix}px, -${(scrollY - windowHeightAfterFix) * speedPink}px, 0)`;
  } else if (scrollY < windowHeightAfterFix) {
    violetBottle.style.transform = null;
    pinkBottle.style.transform = null;
  }
}


const resizeBuffer = (scrollY, buferTop) => {
  if (breakpointXl.matches) {
    if (bufer.getBoundingClientRect().top <= windowHeight * 1.5) {
      bufer.style.height = null;
      buferTop = buferTop = bufer.offsetTop;
      bufer.style.height = `${windowHeight * 1.1 + (scrollY - buferTop) * 2.1}px`;
    } else {
      bufer.style.height = null;
      bufer.style.background= null;
    }
  } else if (breakpointLg.matches) {
    if (bufer.getBoundingClientRect().top <= windowHeight * 1.5) {
      bufer.style.height = null;
      buferTop = buferTop = bufer.offsetTop;
      if (window.matchMedia('(min-height:800px)')) {
        bufer.style.height = `${windowHeight * 0.8 + (scrollY - buferTop) * 1.5}px`;
      } else if (window.matchMedia('(max-height:600px)')) {
        bufer.style.height = `${windowHeight * 3 + (scrollY - buferTop) * 1.5}px`;
      } else {
        bufer.style.height = `${windowHeight * 1.2 + (scrollY - buferTop) * 1.5}px`;
      }
    } else {
      bufer.style.height = null;
      bufer.style.background= null;
    }
  } else {
    if (bufer.getBoundingClientRect().top <= windowHeight * 1.5) {
      bufer.style.height = null;
      buferTop = buferTop = bufer.offsetTop;
      if (window.matchMedia('(min-height:800px)')) {
        bufer.style.height = `${windowHeight / 4 + (scrollY - buferTop) * 1.5}px`;
      } else {
        bufer.style.height = `${windowHeight / 2 + (scrollY - buferTop) * 1.5}px`;
      }
    } else {
      bufer.style.height = null;
      bufer.style.background= null;
    }
  }
}

const horizontalMove = (scrollY) => {
  if (breakpointLg.matches) {
    if (scrollY >= (windowHeight * 1.8)) {
      scrollElHor.forEach((el) => {
        let speed = el.dataset.speed;
        el.style.transform = `translate3d(${(scrollY - (windowHeight * 1.8)) * speed}px, 0, 0)`;
      });
    } else if (scrollY < (windowHeight * 1.8)) {
      scrollElHor.forEach((el) => {
        el.style.transform = null;
      });
    }
  } else {
    if (scrollY > windowHeight * 2.5 && scrollY < windowHeight * 3.5) {
      scrollElHor.forEach((el) => {
        let speed = el.dataset.speed;
        el.style.transform = `translate3d(${(scrollY - (windowHeight * 2.5)) * speed}px, 0, 0)`;
      });
    } else if (scrollY < windowHeight * 2.2) {
      scrollElHor.forEach((el) => {
        el.style.transform = null;
      });
    } else if (scrollY >= windowHeight * 2.2 && scrollY <= windowHeight * 2.5) {
      scrollElHor.forEach((el) => {
        let speed = el.dataset.speed;
        el.style.transform = `translate3d(0, 0, 0)`;
      });
    }
  }
}

const ruleHorizontalMove = (scrollY) => {
  if (!breakpointLg.matches) {
    if (scrollY > windowHeight * 2.5 && scrollY < windowHeight * 3.5) {
      rulesContent.style.position = 'fixed';
      rulesContent.style.top = `${windowHeight / 3.5}px`;
    } else if (scrollY < windowHeight * 2.2) {
      rulesContent.style.position = null;
      rulesContent.style.top = null;
    } else if (scrollY >= windowHeight * 2.2 && scrollY <= windowHeight * 2.5) {
      rulesContent.style.position = 'fixed';
      rulesContent.style.top = `${windowHeight / 3.5}px`;
    } else if (scrollY >= windowHeight * 3.5) {
      rulesContent.style.position = null;
      rulesContent.style.top = null;
    }
  }
}

const moveScrollBottle = (scrollY) => {
  if (!breakpointLg.matches) {
    if (scrollY >= windowHeight * 2.5) {
      scrollBottle.style.position = 'fixed';
      scrollBottle.style.top = '0';
      scrollBottle.querySelectorAll('.elHor').forEach((el) => {
        let speed = el.dataset.speed;
        el.style.transform = `translate3d(${(scrollY - (windowHeight * 2.5)) * speed}px, 0, 0)`;
      });
    } else if (scrollY < windowHeight * 2.5) {
      scrollBottle.style.position = null;
      scrollBottle.style.top = null;
      scrollBottle.querySelectorAll('.elHor').forEach((el) => {
        el.style.transform = null;
      });
    }
  }
}

const verticalMove = (scrollY) => {
  if (breakpointLg.matches) {
    if (scrollY >= windowHeightAfterFix) {
      scrollElVer.forEach((el) => {
        let speed = el.dataset.speed;
        el.style.transform = `translate3d(0, -${(scrollY - windowHeightAfterFix) * speed}px, 0)`;
      });
    } else if (scrollY < windowHeightAfterFix) {
      scrollElVer.forEach((el) => {
        el.style.transform = null;
      });
    }
  } else {
    if (scrollY >= windowHeightAfterFix && scrollY < windowHeight * 2.8) {
      scrollElVer.forEach((el) => {
        let speed = el.dataset.speed;
        el.style.transform = `translate3d(0, -${(scrollY - windowHeightAfterFix) * speed}px, 0)`;
      });
    } else if (scrollY < windowHeightAfterFix) {
      scrollElVer.forEach((el) => {
        el.style.transform = null;
      });
    }
  }
}

const roundMove = (scrollY, speedDesktop, speedMobile) => {
  if (breakpointLg.matches) {
    if (scrollY >= windowHeightAfterFix) {
      scrollElRound.style.opacity = 1;
      if ((scrollY - windowHeightAfterFix) * 0.0007 < 1.5) {
        scrollElRound.style.transform = `translateZ(0) translateY(-${(scrollY - windowHeightAfterFix) * speedDesktop}px) scale(${(scrollY - windowHeightAfterFix) * 0.0007})`;
      } else {
        scrollElRound.style.transform = `translateZ(0) translateY(-${(scrollY - windowHeightAfterFix) * speedDesktop}px) scale(1.5)`;
      }
    } else if (scrollY < windowHeightAfterFix) {
      scrollElRound.style.opacity = 0;
      scrollElRound.style.transform = null;
    }
  } else {
    if (scrollY < windowHeight * 2.8) {
      scrollElRound.style.transform = null;
      scrollElRound.style.opacity = 0;
    } else if (scrollY >= windowHeight * 2.8) {
      scrollElRound.style.opacity = 1;
      if ((scrollY - windowHeightAfterFix) * 0.002 < 3.5) {
        scrollElRound.style.transform = `translateZ(0) translateY(-${(scrollY - windowHeight * 2.8) * speedMobile}px) scale(${(scrollY - windowHeightAfterFix) * 0.002})`;
      } else {
        scrollElRound.style.transform = `translateZ(0) translateY(-${(scrollY - windowHeight * 2.8) * speedMobile}px) scale(3.5)`;
      }
    }
  }
}

const changeColor = (scrollY) => {
  if (breakpointXl.matches) {
    if (scrollY > 0 && scrollY <= windowHeight) {
      separatorSvg.style.fillOpacity = `${1 - (windowHeight - scrollY) / 1000}`;
    } else if (scrollY > windowHeight) {
      separatorSvg.style.fillOpacity = "1";
    } else if (scrollY === 0) {
      separatorSvg.style.fillOpacity = "0";
    }
  } else {
    if (scrollY > 0 && scrollY <= windowHeight) {
      separatorSvg.style.fillOpacity = `${1 - (windowHeight - scrollY) / 800}`;
      if (heroBufer) {
        heroBufer.style.opacity = `${1 - (windowHeight - scrollY) / 800}`;
      }
    } else if (scrollY > windowHeight) {
      separatorSvg.style.fillOpacity = "1";
      if (heroBufer) {
        heroBufer.style.opacity = "1";
      }
    } else if (scrollY === 0) {
      separatorSvg.style.fillOpacity = "0";
      if (heroBufer) {
        heroBufer.style.opacity = "0";
      }
    }
  }
}

const initAnimate = (scrollY, mainBottleLeft, speedDesktop, speedMobile, bufer) => {
  windowHeight = document.documentElement.clientHeight;

  windowHeightAfterFix = 1.5 * windowHeight;
  windowWidth = document.documentElement.clientWidth;
  if (bufer) {
    buferTop = bufer.offsetTop;
  }

  moveMainBottle(scrollY, mainBottleLeft);
  moveVioletBottle(scrollY, mainBottleLeft);
  resizeBuffer(scrollY, buferTop);
  roundMove(scrollY, speedDesktop, speedMobile);
  changeColor(scrollY);
  horizontalMove(scrollY);
  verticalMove(scrollY);
  moveScrollBottle(scrollY);
  ruleHorizontalMove(scrollY);
}

const animateBottle = () => {

  if (!document.querySelector('.page--main')) {
    return;
  }

  let speedDesktop = scrollElRound.dataset.speeddesktop;
  let speedMobile = scrollElRound.dataset.speedmobile;

  if (heroSeparator) {
    separatorSvg = heroSeparator.querySelector('svg');
  }

  scrollElVer.forEach((el) => {
    let speed = el.dataset.speed;
    verticalMove(scrollY, speed);
  });

  windowHeight = document.documentElement.clientHeight;

  windowHeightAfterFix = 1.5 * windowHeight;
  windowWidth = document.documentElement.clientWidth;
  if (bufer) {
    buferTop = bufer.offsetTop;
  }

  initAnimate(scrollY, mainBottleLeft, speedDesktop, speedMobile, bufer);

  window.addEventListener('scroll', () => {
    moveMainBottle(scrollY, mainBottleLeft);
    moveVioletBottle(scrollY, mainBottleLeft);
    resizeBuffer(scrollY, buferTop);
    roundMove(scrollY, speedDesktop, speedMobile);
    changeColor(scrollY);
    horizontalMove(scrollY);
    verticalMove(scrollY);
    moveScrollBottle(scrollY);
    ruleHorizontalMove(scrollY);
  });

  window.addEventListener('resize', () => {
    if (bufer) {
      buferTop = bufer.offsetTop;
    }

    initAnimate(scrollY, mainBottleLeft, speedDesktop, speedMobile, bufer);
  });
}

export {animateBottle};
